<script lang="ts">
    import { getDealer } from "../../../api"
    import { _ } from "svelte-i18n"
    import MiniLoader from "../MiniLoader.svelte"

    let dealer: Dealer
    let notfound = false
    export let number: number

    $: if (typeof window !== "undefined") {
        // @ts-ignore
        if (typeof window._dealerNumberCache == "undefined") {
            // @ts-ignore
            window._dealerNumberCache = {}
        }

        if (number) {
            // @ts-ignore
            let prom = window._dealerNumberCache[number] as Promise<{
                data: Dealer[]
                count?: number
            }>
            if (!prom) {
                prom = getDealer({
                    number,
                })
                // @ts-ignore
                window._dealerNumberCache[number] = prom
            }

            notfound = false
            prom.then((d) => {
                if (d.data.length) {
                    dealer = d.data[0]
                } else {
                    notfound = true
                }
            })
        }
    }
</script>

{#if dealer}
    {dealer.company}
    <br />
    {dealer.street}<br />
    {dealer.postcode}
    {dealer.city}
{:else if notfound}
    {$_("general.dealerDataNotFound")}
{:else}
    <MiniLoader />
{/if}
